<template>
  <div>
    <div class="box"></div>
    <div class="content">
      <div class="lef">
        <div>智慧工地产品</div>
        <p v-for="(item,index) in btnList" :key="item.id">
          <a :class="{'don':selectedIndex === index}" @click="changeSelected(item,index)">· {{ item.name }}</a>
        </p>
      </div>
      <div class="right">
        <component :is="selectedPage"></component>
        <div class="but">
          <span class="l" @click="upClick()">上一篇</span>
          <span class="r" @click="nextClick()">下一篇</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Company from '@/components/scheme/site-page/Company';
import Project from "@/components/scheme/site-page/Project";

export default {
  components: {
    Company, Project
  },
  data() {
    return {
      selectedIndex: 0,
      selectedPage: '',
      btnList: [
        {name: '企业集团级智慧工地云平台', page: 'company'},
        {name: '项目级智慧工地云平台', page: 'project'},
      ],
    }
  },
  methods: {
    upClick() {
      if (this.selectedIndex === 0) {
        return;
      }
      this.selectedIndex--;
      this.selectedPage = this.btnList[this.selectedIndex].page;
      document.documentElement.scrollTop = 0;
    },
    nextClick() {
      if (this.selectedIndex === this.btnList.length - 1) {
        return;
      }
      this.selectedIndex++;
      this.selectedPage = this.btnList[this.selectedIndex].page;
      document.documentElement.scrollTop = 0;
    },
    changeSelected(__item, __index) {
      if (__item.page) {
        this.selectedIndex = __index;
        this.selectedPage = __item.page;
        document.documentElement.scrollTop = 0;
      }
    }
  },
  mounted() {
    this.selectedIndex = parseInt(this.$route.query.index);
    this.selectedPage = this.btnList[this.selectedIndex].page;
    document.documentElement.scrollTop = 0;
  }
}
</script>

<style lang="scss" scoped>
.box {
  height: 2.9rem;
  width: 100%;
  background: url("./img/banner/1.jpg");
  background-size: 100% 100%;
}

.box2 {
  width: 12rem;
  margin: .6rem auto 0;
  display: flex;

  .lef {
    width: 1.76rem;
    overflow: hidden;

    div {
      font-size: .2rem;
      position: relative;
      padding-left: .1rem;
      margin-bottom: .19rem;
    }

    div::before {
      position: absolute;
      content: "";
      left: 0rem;
      top: .06rem;
      background: #E70F20;
      width: 2px;
      height: .16rem;
    }

    p {
      line-height: .34rem;
      font-size: .16rem;
      width: 1.76rem;
      color: #3F3F3F;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
      cursor: pointer;

      a {
        display: inline-block;
        width: 100%;
      }
    }

    .don {
      color: #E70F20
    }
  }

  .rit {
    margin-left: .15rem;
    border-left: 1px solid #E5E5E5;
    padding-left: .85rem;
    width: 10.07rem;

    p.tit {
      width: 5.7rem;
      font-size: .26rem;
      text-align: center;
      margin: 0 auto;
      line-height: .41rem;
      letter-spacing: 1px;
    }

    div.img {
      text-align: center;
      margin-top: .52rem;

      img {
        width: 7rem;
        height: 3.94rem;
      }
    }

    div.txt {
      margin-top: .44rem;
      line-height: .36rem;
      color: #595757;
      font-size: .18rem;
      text-align: justify;
    }

  }

  .prop {
    width: 10rem;
    font-size: .26rem;
    color: #ddd;
    text-align: center;
    padding-top: 1rem;
  }
}

.content {
  width: 12rem;
  margin: .5rem auto 0;
  display: flex;

  .lef {
    margin-right: .24rem;
    width: 2.2rem;
    overflow: hidden;

    div {
      font-size: .2rem;
      position: relative;
      padding-left: .1rem;
      margin-bottom: .19rem;
    }

    div::before {
      position: absolute;
      content: "";
      left: 0rem;
      top: .06rem;
      background: #E70F20;
      width: 2px;
      height: .16rem;
    }

    p {
      line-height: .34rem;
      font-size: .16rem;
      width: 2.2rem;
      color: #3F3F3F;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
      cursor: pointer;

      a {
        display: inline-block;
        width: 100%;
      }
    }

    .don {
      color: #E70F20
    }
  }

  .right {
    width: 10rem;

    .but {
      text-align: center;
      margin-top: .56rem;

      span {
        width: 69px;
        height: 26px;
        line-height: 29px;
        display: inline-block;
        font-size: 12px;
        margin: 0 .25rem;
        cursor: pointer;
      }

      .l {
        background: url("../../assets/images/pg.png");
        background-size: 100% 100%;
        padding-left: .07rem
      }

      .r {
        background: url("../../assets/images/pg2.png");
        background-size: 100% 100%;
        padding-right: .07rem
      }
    }
  }
}
</style>
